import * as React from "react";

import moment from "moment";

import { Button } from "src/components/buttons";

import { Input, Form, Modal, Select, Radio } from "antd";
import DatasetAuthorizationWrapper from "src/common/DatasetAuthorizationWrapper";
// tslint:disable-next-line:max-line-length
import {
	CustomFieldContainer,
	getCustomFieldValidation,
	getCustomFieldValues,
	ICustomFieldValidation,
} from "src/admin/Organization/CustomFields/CustomFieldContainer";
import CustomFieldInfo from "src/components/forms/CustomFieldInfo";
import ClientAPI from "./ClientAPI";

import pickListContext from "src/context/pickListContext";

import {
	alphaNumericDashInputRegex,
	alphaNumCommaDotDashInputRegex,
	numericInputRegex,
	Validation,
} from "src/common/utils";
import { Spinner } from "src/components/common";
import { ClientPermissions } from "src/common/Permissions";
import DatasetAPI from "src/admin/Organization/Datasets/DatasetAPI";
import ClientDatasetSelector from "src/components/forms/ClientDatasetSelector";
import { toast } from "react-toastify";
import NeurapulseUnlinkModal from "src/components/neurapulse/NeurapulseUnlinkModal";

interface IClientDetailsProps {
	match?: any;
	history?: any;
}

interface IClientDetailsState {
	clientDetails: ClientDTO;
	clientId: number;
	openModal: boolean;
	openCancellationModal: boolean;
	loading: boolean;
	clientDetailsSubmitted: boolean;
	clientCustomFieldValidation: string[];
	isLoading: boolean;
	datasetList: DatasetDTO[];
	homeDataset: DatasetDTO;
}

interface IBirthdateValidator {
	yearRange: number;
	dayRange: number;
}

const { Option } = Select;
// *Do not refactor this part! InputDropdownAnt cannot handle birthMonth as required
const months = [
	{
		name: "Jan",
		value: 1,
	},
	{
		name: "Feb",
		value: 2,
	},
	{
		name: "Mar",
		value: 3,
	},
	{
		name: "Apr",
		value: 4,
	},
	{
		name: "May",
		value: 5,
	},
	{
		name: "Jun",
		value: 6,
	},
	{
		name: "Jul",
		value: 7,
	},
	{
		name: "Aug",
		value: 8,
	},
	{
		name: "Sep",
		value: 9,
	},
	{
		name: "Oct",
		value: 10,
	},
	{
		name: "Nov",
		value: 11,
	},
	{
		name: "Dec",
		value: 12,
	},
];

class ClientDetails extends React.Component<
	IClientDetailsProps,
	IClientDetailsState
> {
	public static contextType = pickListContext;
	constructor(props: IClientDetailsProps) {
		super(props);
		this.state = {
			clientId: Number(this.props.match.params.clientId),
			clientDetails: {
				id: Number(this.props.match.params.clientId),
				birthYear: undefined,
				isActive: true,
				customFieldValues: [],
			} as ClientDTO,
			openModal: false,
			openCancellationModal: false,
			loading: true,
			clientDetailsSubmitted: false,
			clientCustomFieldValidation: [],
			isLoading: true,
			datasetList: [],
			homeDataset: {},
		};
	}

	private loadData() {
		const organizationId = this.props.match.params.organizationId;
		const datasetId: number = +this.props.match.params.datasetId;

		const p_clientSiteClient = ClientAPI.getClientSiteClient({
			datasetId: datasetId,
			clientId: this.props.match.params.clientId,
		});

		const p_dataset = DatasetAPI.getClientSiteOrganizationDatasets(
			organizationId,
			"userCount"
		);

		Promise.all([p_clientSiteClient, p_dataset]).then((values) => {
			const [client, datasets] = values;

			if (client.clientDatasets === undefined) {
				var homeClientDataset: ClientXrefDatasetsDTO = {
					clientId: client.id,
					datasetId: datasetId,
					homeDataset: true,
				};
				client.clientDatasets = [homeClientDataset];
			}

			let activeDataset = {};

			if (datasets.length > 0) {
				datasets.forEach((dataset) => {
					if (datasetId === dataset.id) {
						activeDataset = dataset;
					}
				});
			}

			// If new client set defaults
			if (!client.id || client.id <= 0) {
				client.birthYear = undefined;
				client.isActive = true;
				client.customFieldValues = [];
			}

			this.setState({
				clientDetails: client,
				datasetList: datasets,
				homeDataset: activeDataset,
				loading: false,
				isLoading: false,
			});
		});
	}

	public componentDidMount() {
		this.loadData();
	}

	public render() {
		const { clientDetails, homeDataset } = this.state;
		// const customFieldsComponents = this.customFieldComponent();
		const validClientDetails = {
			birthYear: Validation.runMultipleValidations(
				[Validation.validateBirthYear, Validation.validateAge],
				[],
				clientDetails
			),
			customFieldValues:
				this.state.clientCustomFieldValidation.length > 0
					? this.state.clientCustomFieldValidation
					: [],
			birthMonth: Validation.validateAge(clientDetails),
			birthDay: Validation.validateAge(clientDetails),
			email: Validation.validateOptionalEmail(clientDetails.email),
		};

		const dateValidator = this.generateDateValidator();
		const newClientModal = this.newClientModal(validClientDetails);
		const saveButtonForExistingClient =
			this.editExistingClientSaveButton(validClientDetails);
		const IdText =
			homeDataset.productId === "ExceleRATEV2" ? "Employee Id" : "Id";

		return this.state.isLoading !== false ? (
			<Spinner />
		) : (
			<div className="container-fluid">
				{this.state.loading ? (
					<Spinner />
				) : (
					<React.Fragment>
						<div className="row">
							<div className="col mb-5">
								<p className="d-inline-block mr-3">
									<span className="font-weight-bold">Participant Code:</span>
									&nbsp;
									{this.state.clientDetails.clientCode}
								</p>
								<p className="d-inline-block mr-3">
									<span className="font-weight-bold">Created:</span>&nbsp;
									{moment
										.utc(this.state.clientDetails.createdDate)
										.local()
										.format("MMM DD, YYYY")}
								</p>
								<p className="d-inline-block mr-3">
									<span className="font-weight-bold">Last Modified:</span>&nbsp;
									{moment
										.utc(this.state.clientDetails.lastModifiedDate)
										.local()
										.format("MMM DD, YYYY")}
								</p>
								<p className="d-inline-block mr-3">
									<span className="font-weight-bold">Active:</span>&nbsp;
									{this.state.clientDetails.isActive ? (
										<span>Active</span>
									) : (
										<span>InActive</span>
									)}
								</p>
								<CustomFieldInfo
									customFieldValues={
										this.state.clientDetails.customFieldValues!
									}
								/>
							</div>
						</div>
						<div className="row">
							{homeDataset.showClientFirstName && (
								<div className="col-3 form-group">
									<label htmlFor="firstName">First name</label>
									<Form.Item>
										<DatasetAuthorizationWrapper
											type="disable"
											permissions={[ClientPermissions.EditClient]}
										>
											<Input
												value={this.state.clientDetails.firstName}
												disabled={
													this.state.clientDetails.redacted ? true : false
												}
												type="text"
												maxLength={20}
												id="firstName"
												name="firstName"
												onChange={this.onChangeField}
											/>
										</DatasetAuthorizationWrapper>
									</Form.Item>
								</div>
							)}
							{homeDataset.showClientLastName && (
								<div className="col-3 form-group">
									<label htmlFor="lastName">Last name</label>
									<Form.Item>
										<DatasetAuthorizationWrapper
											type="disable"
											permissions={[ClientPermissions.EditClient]}
										>
											<Input
												value={this.state.clientDetails.lastName}
												disabled={
													this.state.clientDetails.redacted ? true : false
												}
												type="text"
												maxLength={20}
												id="lastName"
												name="lastName"
												onChange={this.onChangeField}
											/>
										</DatasetAuthorizationWrapper>
									</Form.Item>
								</div>
							)}
							<div className="col-3 form-group">
								<label htmlFor="email">Email</label>
								<Form.Item
									hasFeedback={true}
									validateStatus={validClientDetails.email.validationStatus}
									help={validClientDetails.email.message}
								>
									<DatasetAuthorizationWrapper
										type="disable"
										permissions={[ClientPermissions.EditClient]}
									>
										<Input
											id="email"
											name="email"
											type="email"
											placeholder="example@email.com"
											value={this.state.clientDetails.email}
											disabled={
												this.state.clientDetails.redacted ? true : false
											}
											onChange={this.onChangeField}
										/>
									</DatasetAuthorizationWrapper>
								</Form.Item>
							</div>
						</div>
						<div className="row">
							{homeDataset.productId === "DriveABLE" ? (
								<div className="col-3 form-group">
									<label htmlFor="address">Address</label>
									<Form.Item>
										<DatasetAuthorizationWrapper
											type="disable"
											permissions={[ClientPermissions.EditClient]}
										>
											<Input
												id="address"
												name="address"
												disabled={
													this.state.clientDetails.redacted ? true : false
												}
												type="text"
												value={this.state.clientDetails.address}
												onChange={this.onChangeField}
											/>
										</DatasetAuthorizationWrapper>
									</Form.Item>
								</div>
							) : null}
							{homeDataset.productId === "DriveABLE" ? (
								<div className="col-3 form-group">
									<label htmlFor="phone">Phone</label>
									<Form.Item>
										<DatasetAuthorizationWrapper
											type="disable"
											permissions={[ClientPermissions.EditClient]}
										>
											<Input
												id="phone"
												name="phone"
												type="text"
												disabled={
													this.state.clientDetails.redacted ? true : false
												}
												value={this.state.clientDetails.phone}
												onChange={this.onChangeField}
											/>
										</DatasetAuthorizationWrapper>
									</Form.Item>
								</div>
							) : null}
							{homeDataset.showClientParticipantId && (
								<div className="col-3 form-group">
									<label htmlFor="employeeId">{IdText}</label>
									<Form.Item>
										<DatasetAuthorizationWrapper
											type="disable"
											permissions={[ClientPermissions.EditClient]}
										>
											<Input
												value={this.state.clientDetails.employeeId}
												disabled={
													this.state.clientDetails.redacted ? true : false
												}
												id="employeeId"
												name="employeeId"
												maxLength={40}
												onChange={this.onChangeField}
											/>
										</DatasetAuthorizationWrapper>
									</Form.Item>
								</div>
							)}
						</div>
						<div className="row">
							<div className="col-3 form-group">
								<label htmlFor="birthDay">Birth year *</label>
								<Form.Item
									hasFeedback={true}
									validateStatus={validClientDetails.birthYear.validationStatus}
									help={validClientDetails.birthYear.message}
								>
									<Input
										id="birthYear"
										name="birthYear"
										disabled={this.state.clientId !== -1}
										value={this.state.clientDetails.birthYear}
										onChange={(e: any) =>
											this.onDateFieldChange(e, dateValidator)
										}
									/>
								</Form.Item>
								<p className="text-muted">
									Cannot be changed once the client is created
								</p>
							</div>
							{homeDataset.showClientBirthMonth && (
								<div className="col-3 form-group">
									<label htmlFor="birthMonth">Birth month</label>
									<Form.Item
										hasFeedback={true}
										validateStatus={
											validClientDetails.birthMonth.validationStatus
										}
										help={
											this.state.clientDetails.birthMonth &&
											validClientDetails.birthMonth.message
										}
									>
										<DatasetAuthorizationWrapper
											type="disable"
											permissions={[ClientPermissions.EditClient]}
										>
											<Select
												placeholder="Choose a month"
												value={this.state.clientDetails.birthMonth}
												disabled={
													this.state.clientDetails.redacted ? true : false
												}
												onChange={(value: any) =>
													this.onBirthMonthChange(value)
												}
											>
												{months.map((m) => {
													return (
														<Option key={m.name} value={m.value}>
															{m.name}
														</Option>
													);
												})}
											</Select>
										</DatasetAuthorizationWrapper>
									</Form.Item>
								</div>
							)}
							{homeDataset.showClientBirthDay && (
								<div className="col-3 form-group">
									<label htmlFor="birthDay">Birth day</label>
									<Form.Item
										hasFeedback={true}
										validateStatus={
											validClientDetails.birthDay.validationStatus
										}
										help={
											this.state.clientDetails.birthDay &&
											validClientDetails.birthDay.message
										}
									>
										<Input
											id="birthDay"
											name="birthDay"
											value={this.state.clientDetails.birthDay}
											disabled={
												this.state.clientDetails.redacted ? true : false
											}
											onChange={(e: any) =>
												this.onDateFieldChange(e, dateValidator)
											}
										/>
									</Form.Item>
								</div>
							)}
						</div>
						<div className="row">
							<CustomFieldContainer
								customFieldTypes={["ClientType"]}
								pickListItems={this.context.pickListItems}
								datasetId={+this.props.match.params.datasetId}
								organizationId={+this.props.match.params.organizationId}
								getCustomFieldValidation={this.getClientCustomFieldValidation}
								getCustomFieldValueFromState={this.getClientCustomFieldValues}
								customFieldTypeIds={
									+this.props.match.params.clientId !== -1
										? {
												typeOfCustomFieldValue: "ClientType",
												value: +this.props.match.params.clientId,
										  }
										: undefined
								}
							/>
						</div>
						<div className="row">
							<div className="col-3 form-group">
								<label htmlFor="isActive">Status</label>
								<Form.Item>
									<DatasetAuthorizationWrapper
										type="disable"
										permissions={[ClientPermissions.EditClient]}
									>
										<Radio.Group
											id="isActive"
											name="isActive"
											value={clientDetails.isActive}
											onChange={this.onIsActiveChange}
										>
											{[
												{ label: "Active", value: true },
												{ label: "InActive", value: false },
											].map((item, index) => {
												return (
													<Radio key={index} value={item.value}>
														{item.label}
													</Radio>
												);
											})}
										</Radio.Group>
									</DatasetAuthorizationWrapper>
								</Form.Item>
							</div>
						</div>
						<div className="row">
							<div className="col form-group">
								<label htmlFor="ClientDatasets">Participant Datasets</label>
								<Form.Item>
									<DatasetAuthorizationWrapper
										type="disable"
										permissions={[ClientPermissions.EditClient]}
									>
										<ClientDatasetSelector
											client={this.state.clientDetails}
											datasets={this.state.datasetList}
											onClientDatasetsAdd={(cxd: ClientXrefDatasetsDTO[]) => {
												let updatedClient = this.state.clientDetails;
												if (cxd) {
													updatedClient.clientDatasets = cxd;
													this.setState({ clientDetails: updatedClient });
												}
											}}
											onClientDatasetsDelete={(datasetId: number) => {
												let updatedClient = this.state.clientDetails;
												if (datasetId) {
													const clientDatasets = updatedClient.clientDatasets;
													if (clientDatasets) {
														const updatedClientDatasets = clientDatasets.filter(
															(cd) => cd.datasetId !== datasetId
														);
														updatedClient.clientDatasets =
															updatedClientDatasets;
														this.setState({ clientDetails: updatedClient });
													}
												}
											}}
											onNeurapulseUnlink={() => {
												this.loadData();
											}}
										/>
									</DatasetAuthorizationWrapper>
								</Form.Item>
							</div>
						</div>
						<DatasetAuthorizationWrapper
							type="hide"
							permissions={[ClientPermissions.EditClient]}
						>
							{this.state.clientId === -1
								? newClientModal
								: saveButtonForExistingClient}
						</DatasetAuthorizationWrapper>
					</React.Fragment>
				)}
			</div>
		);
	}

	// exported from customfield container
	private getClientCustomFieldValues = (
		customFieldValues: CustomFieldValueDTO[]
	) => {
		const clientCustomFieldValues = getCustomFieldValues(customFieldValues);
		const client = this.state.clientDetails;
		if (clientCustomFieldValues.length > 0) {
			client.customFieldValues = clientCustomFieldValues;
			this.setState({ clientDetails: client });
		}

		return;
	};

	private getClientCustomFieldValidation = (
		validation: ICustomFieldValidation[]
	) => {
		const validCustomFieldValues = getCustomFieldValidation(validation);
		const validCustomFieldValuesValidationStatus = validCustomFieldValues.map(
			(c) => {
				if (c.validationStatus === undefined) {
					// just need to know if its success or error this is an edge case
					return "";
				} else {
					return c.validationStatus;
				}
			}
		);
		this.setState({
			clientCustomFieldValidation: validCustomFieldValuesValidationStatus,
		});
	};

	private returnBirthMonthName = (value?: number) => {
		const month = months.find((m) => m.value === value);
		return month ? month.name : "";
	};

	private newClientModal = (validClientDetails: any) => {
		const firstName = this._firstName(this.state.clientDetails.firstName!);
		const lastName = this._lastName(this.state.clientDetails.lastName!);

		return (
			<div>
				{this.state.loading !== true ? (
					<React.Fragment>
						<Button
							className="btn-primary mr-3"
							onClick={this.openModal}
							disabled={!this.isValid(validClientDetails)}
						>
							Save
						</Button>
						<Button
							className="btn-outline-primary"
							onClick={() =>
								this.props.history.push(
									`/organizations/${this.props.match.params.organizationId}/datasets/${this.props.match.params.datasetId}/clients`
								)
							}
						>
							Cancel
						</Button>
					</React.Fragment>
				) : (
					<Spinner />
				)}
				<Modal
					visible={this.state.openModal}
					title="Participant details confirmation"
					onOk={this.submitClient}
					onCancel={this.closeModal}
					okButtonProps={{
						disabled: this.state.loading,
					}}
					width={"30%"}
					okText="Confirm"
				>
					<p>
						The date cannot be changed once the participant is created. Please
						confirm information below is correct
					</p>
					<p>
						<b>Name: </b> {`${firstName} ${lastName}`}&nbsp;
					</p>
					<p>
						<b>Date of Birth: </b>
						{`${
							!this.isEmptyOrUndefined(this.state.clientDetails.birthMonth)
								? this.returnBirthMonthName(
										this.state.clientDetails.birthMonth
								  ) + " - "
								: ""
						}
							${
								!this.isEmptyOrUndefined(this.state.clientDetails.birthDay)
									? this.state.clientDetails.birthDay + " - "
									: ""
							}
							${this.state.clientDetails.birthYear}`}
					</p>
				</Modal>
			</div>
		);
	};

	private editExistingClientSaveButton = (validClientDetails: any) => {
		return this.state.loading !== true ? (
			<React.Fragment>
				<Button
					className="btn-primary mr-3"
					onClick={this.submitClient}
					disabled={!this.isValid(validClientDetails)}
				>
					Save
				</Button>
			</React.Fragment>
		) : (
			<Spinner />
		);
	};

	private generateDateValidator = () => {
		const { birthYear, birthMonth, birthDay } = this.state.clientDetails;
		const isLeapYear =
			birthYear && ((!(birthYear % 4) && birthYear % 100) || !(birthYear % 400))
				? true
				: false;
		const days = isLeapYear
			? [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
			: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		const validator = {
			yearRange: new Date().getFullYear(),
			monthRange: 12,
			dayRange: birthMonth ? days[birthMonth - 1] : 31,
		} as IBirthdateValidator;
		if (
			(birthDay && birthDay > validator.dayRange) ||
			(birthDay && birthDay === 0)
		) {
			this.setState({
				clientDetails: {
					...this.state.clientDetails,
					birthDay: validator.dayRange,
				},
			});
		}
		return validator;
	};

	private onBirthMonthChange = (value: any) => {
		this.setState({
			clientDetails: { ...this.state.clientDetails, birthMonth: value },
		});
	};

	private isValid = (validClientDetails: any) => {
		// use model for validation, change flatmap cause it may be unneeded
		return Validation.isValidIncludingCustomFields(
			validClientDetails,
			"customFieldValues"
		);
	};

	private onChangeField = (e: any) => {
		if (
			(e.target.name === "firstName" || e.target.name === "lastName") &&
			!e.target.value.match(alphaNumericDashInputRegex)
		) {
			return;
		}
		if (
			e.target.name === "address" &&
			!e.target.value.match(alphaNumCommaDotDashInputRegex)
		) {
			return;
		}
		if (e.target.name === "phone" && !e.target.value.match(numericInputRegex)) {
			return;
		}
		const clientDetails = { ...this.state.clientDetails };
		clientDetails[e.target.name] = e.target.value;
		this.setState({ clientDetails });
	};

	private onDateFieldChange = (evt: any, validator: IBirthdateValidator) => {
		const value = evt.target.value;
		// input type = number still allows to input character 'e' and 'E'
		if (!value.match(numericInputRegex)) {
			return;
		}
		switch (evt.target.name) {
			case "birthYear":
				if (value > validator.yearRange) {
					break;
				}
				this.setState({
					clientDetails: { ...this.state.clientDetails, birthYear: value },
				});
				break;
			case "birthDay":
				if (value > validator.dayRange || value === "0") {
					break;
				}
				this.setState({
					clientDetails: { ...this.state.clientDetails, birthDay: value },
				});
				break;
			default:
				break;
		}
	};

	private onIsActiveChange = (e: any) => {
		const clientDetails = { ...this.state.clientDetails };
		clientDetails[e.target.name] = e.target.value;
		this.setState({ clientDetails });
	};

	private isEmptyOrUndefined = (value: any) =>
		value === undefined || value.length === 0;

	private openModal = () => {
		this.setState({ openModal: true });
	};

	private closeModal = () => {
		this.setState({ openModal: false });
	};

	private _firstName = (name: string) => {
		return this.isEmptyOrUndefined(name) ? "Unnamed" : name!.trim();
	};

	private _lastName = (name: string) => {
		return this.isEmptyOrUndefined(name) ? "Participant" : name!.trim();
	};

	private submitClient = () => {
		const clientDetails = { ...this.state.clientDetails };
		const firstName = this._firstName(this.state.clientDetails.firstName!);
		const lastName = this._lastName(this.state.clientDetails.lastName!);

		clientDetails.organizationId = this.props.match.params.organizationId;
		clientDetails.datasetId = clientDetails.datasetId
			? clientDetails.datasetId
			: this.props.match.params.datasetId;
		clientDetails.firstName = firstName;
		clientDetails.lastName = lastName;

		this.setState({ loading: true });
		if (this.state.clientId === -1) {
			clientDetails.id = -1;
		}

		ClientAPI.upsertClientSiteClient(clientDetails).then(() => {
			this.setState({ loading: false });
			this.props.history.push(
				`/organizations/${this.props.match.params.organizationId}/datasets/${this.props.match.params.datasetId}/clients`
			);
			toast.success("Participant updated successfully");
		});
		// this.setState({ clientDetailsSubmitted: true });
	};
}

export default ClientDetails;
